export default __webpack_public_path__ + "static/media/eyeglass-2.3aa01f7a.svg";